import React, { useEffect, useRef, useState } from "react";
import { Info } from "lucide-react";

/**
 * Small info icon for dashboard tiles. The explanation appears on hover (desktop)
 * and on click/tap (mobile). Sits in the top-right area of a tile.
 */
export const InfoTip: React.FC<{ text: string }> = ({ text }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  return (
    <div
      className="relative flex"
      ref={ref}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="Info"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        className="text-muted-foreground/40 hover:text-muted-foreground transition-colors"
      >
        <Info className="h-4 w-4" />
      </button>
      {open && (
        <div className="absolute z-50 bottom-full right-0 mb-2 p-3 bg-popover border border-border rounded-md shadow-md w-64 text-left">
          <p className="text-xs text-popover-foreground leading-relaxed">{text}</p>
        </div>
      )}
    </div>
  );
};
